// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"24":"4befbd851234ff1f","519":"331bb44bcbb4916c","876":"b47d25ce17e344f0"}[chunkId] + "";
};